import { useGetBanner } from '@ordr-as/ordr-service-types/epos';

export function useQueryBanner(locationId: string) {
  const { queryKey: _queryKey, ...result } = useGetBanner(locationId, {
    query: {
      staleTime: 300_000,
    },
  });
  return result;
}
